import {useContext, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

import {ProfileContext} from 'contexts/ProfileContext';
import Gate from 'contexts/Gate';
import {isHeadTa} from 'contexts/profileUtil';
import {useCourseId} from 'hooks/router/useUrlParams';

export const HomeRedirect = () => {
  // redirect to highest role home
  const navigate = useNavigate();
  const courseId = useCourseId();
  const {userData} = useContext(ProfileContext);
  const isAdmin = Gate.hasAdminRole(userData);
  // Gate has no TA-only helper (Gate.hasStaffRole is TA-or-higher), so use
  // profileUtil's exact-role check. This keeps the TA branch independent of
  // the order-of-checks above (admin is filtered out first).
  const isTa = isHeadTa(userData?.courseRole);
  const isTeachingTeam = Gate.hasSectionLeaderRole(userData);
  const isMentor = Gate.hasMentorRole(userData);

  useEffect(() => {
    if (isAdmin) {
      // redirect to admin home
      navigate(`/${courseId}/adminhome`, {replace: true});
      return;
    }
    if (isTa) {
      // redirect to ta home
      navigate(`/${courseId}/tahome`, {replace: true});
      return;
    }
    if (isTeachingTeam) {
      // redirect to teaching home
      navigate(`/${courseId}/teachinghome`, {replace: true});
      return;
    }
    if (isMentor) {
      // redirect to mentor home
      navigate(`/${courseId}/mentorhome`, {replace: true});
      return;
    }
    // redirect to student home
    navigate(`/${courseId}/studenthome`, {replace: true});
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  }, [isTeachingTeam, isAdmin, isTa, isMentor]);
  return <></>;
};
